import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { RadioGroup, SectionHeader, Text } from "@pentabd/ui";

import { InputTextAreaRow, InputTextRow } from "@components";

import { FORM_FIELDS } from "@constants/form";

const TENDER_EVOLUTION = FORM_FIELDS.PROCUREMENT_DETAILS.TENDER_EVOLUTION;

export default function TenderInfo() {
  const { t } = useTranslation();
  const { register } = useFormContext();

  return (
    <div className="pt-10">
      <SectionHeader
        title={t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TENDER_INFO")}
      />
      <div className="pt-10 d-flex flex-column gap-6">
        <InputTextRow
          label="PROCUREMENT_CREATE.TENDER_EVOLUTION.SELECT_VENDOR_FOR_NOA"
          register={{ ...register(TENDER_EVOLUTION.SELECT_VENDOR_FOR_NOA) }}
          disabled
        />

        <div className="row">
          <div className="col-lg-3">
            <Text weight="semibold" color="title" size="sm">
              {t("PROCUREMENT_CREATE.TENDER_EVOLUTION.TENDER_STATUS.LABEL")}
            </Text>
          </div>
          <div className="col-lg-7">
            <RadioGroup
              id={TENDER_EVOLUTION.TENDER_STATUS}
              {...register(TENDER_EVOLUTION.TENDER_STATUS)}
              options={[
                {
                  id: "1",
                  label: t(
                    "PROCUREMENT_CREATE.TENDER_EVOLUTION.TENDER_STATUS.APPROVED",
                  ),
                  value: "APPROVED",
                },
                {
                  id: "2",
                  label: t(
                    "PROCUREMENT_CREATE.TENDER_EVOLUTION.TENDER_STATUS.REJECTED",
                  ),
                  value: "REJECTED",
                },
              ]}
            />
          </div>
        </div>

        <InputTextAreaRow
          label="PROCUREMENT_CREATE.TENDER_EVOLUTION.TENDER_STATUS_COMMENT"
          register={{ ...register(TENDER_EVOLUTION.TENDER_STATUS_COMMENT) }}
        />

        <InputTextAreaRow
          label="PROCUREMENT_CREATE.TENDER_EVOLUTION.VENDOR_SECTION_COMMENT"
          register={{ ...register(TENDER_EVOLUTION.VENDOR_SECTION_COMMENT) }}
        />
      </div>
    </div>
  );
}
